module.exports = __webpack_public_path__ + "static/media/banner-asset-3.b28e9285.png";